import{TahsillistComponent}from '../components/tahsil/tahsillist.component';
import { Injectable,Component } from '@angular/core';
import { HttpHeaders}  from '@angular/common/http';  
import { Observable,throwError  } from 'rxjs';  
import { HttpClient, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { DataAccessService } from '../../shared/services/dataaccess.service';

export class GridColumns {
  caption: string;
  dataField: string;
  dataType: string;
  cssClass: string;
  allowSorting: boolean;
};
export class Tahsil {
  TahsilID:number;
  DistrictID:number;
  DistrictName:string;
  TahsilName:string;
  TahsilShortName:string;
  TahsilCode:string;
  CreatedLoginID:number;
  UpdatedLoginID:number; 
}

let gridColumns: GridColumns[] = [    
{
  "caption": 'District Name',
  "dataField": "DistrictName",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Name',
  "dataField": "TahsilName",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Short Name',
  "dataField": "TahsilShortName",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
},
{
  "caption": 'Code',
  "dataField": "TahsilCode",
  "dataType": "string",
  "cssClass": "",
  "allowSorting": true
}
]; 

/* @Component({
  providers: [DataAccessService]
}) */
@Injectable({
  providedIn: 'root'
})
export class TahsilService {
  constructor(
    private dataService: DataAccessService) {
  }
  public TahsilData: Tahsil;
  public errormsg;
  public successmsg;
  public getAllTahsil() {
    this.dataService.setControllerName = '/BasicTahsils/';
    this.dataService.setMethodName = 'GetBasicTahsilsList?TahsilID=0'; // setting method name from API controller.
    return this.dataService.getAll<Tahsil[]>()
  }
  public getAllTahsilList() {
    this.dataService.setControllerName = '/BasicTahsils/';
    this.dataService.setMethodName = 'GetBasicTahsilsForList?TahsilID=0'; // setting method name from API controller.
    return this.dataService.getAll<Tahsil[]>()
  } 
  public getTahsilByID(TahsilID) {
    this.dataService.setControllerName = '/BasicTahsils/';
    this.dataService.setMethodName = 'GetBasicTahsilsList?TahsilID=' + TahsilID +''; // setting method name from API controller.
    return this.dataService.getAll<Tahsil[]>()
  }
  public getTahsilByDistrictID(DistrictID) {
    this.dataService.setControllerName = '/BasicTahsils/';
    this.dataService.setMethodName = 'GetBasicTahsilsByDistrictID?DistrictID=' + DistrictID +''; // setting method name from API controller.
    return this.dataService.getAll<Tahsil[]>()
  }
 /*  public getTahsilByID() {
    this.dataService.setControllerName = '/BasicTahsils/';
    this.dataService.setMethodName = 'GetBasicTahsilsList';
    this.dataService
      .getSingle<Tahsil>('?TahsilID=0')    
      .subscribe((data: Tahsil) => this.TahsilData = data,
        error => () => {
        },
        () => {
              return this.TahsilData;
        });
  } */
  public save(data) {
    this.dataService.setControllerName = '/BasicTahsils/';
    this.dataService.setMethodName = 'PostInsertBasicTahsils'; // setting method name from API controller.
    return this.dataService.add<Tahsil[]>(data) 
  }
  public update(data) {
    this.dataService.setControllerName = '/BasicTahsils/';
    this.dataService.setMethodName = 'PostBasicTahsils'; // setting method name from API controller.
    return this.dataService.add<Tahsil[]>(data)
  }
  public delete(data) {
    this.dataService.setControllerName = '/BasicTahsils/';
    this.dataService.setMethodName = 'PostDeleteBasicTahsils'; // setting method name from API controller.
    return this.dataService.delete<Tahsil[]>(data)
  }

  getGridColumnsData() {
    return Tahsil[0];
  }
  getGridColumns() {
    return gridColumns;
  } 
}
